import toast from "./toast";
import axios from "axios";
import userManager from "@amsom-habitat/user-manager";
import authAPI from "@/services/authAPI";

export default function axiosOverlay(config) {
    const token = authAPI.storeToken.token ?? userManager.getToken()
    const instance = axios.create()
    instance.defaults.headers.common['Authorization'] = "Bearer " + token
    instance.defaults.headers.common['Accept'] = "application/json"

    return instance(config)
        .then(response => {
            // Ici surcharger le comportement de axios pour un resolve

            // 1. Exemple de gestion de code générique :
            //  Si on a un code xxx on génère une action

            /*
            if (response.status === 200) {
                console.log("BRAVO : " + response.status)
            }
            */

            // On revoie systematiquement la promesse de axios
            return response
        })
        .catch(async error => {
            // log des erreurs en cas de mode dev
            if (process.env.VUE_APP_DEBUG_ENABLED === "true") console.log(error)
            if (error.toString() == "Cancel") {
                if (process.env.VUE_APP_DEBUG_ENABLED === "true") console.log("Cancel déclenché")
            } else {

                //surcharge des codes erreur
                if (error.response && error.response.status === 449) {
                    authAPI.storeToken.token = error.response.data.token
                }

                //On vérifie que l'erreur soit pas du au fait que nous ayons nous meme deja update le token
                if (token !== authAPI.storeToken.token) {
                    return axiosOverlay(config)
                }

                if (error.response.status === 401) {
                    window.stop()
                    await authAPI.logout()
                    userManager.goToLoginPage();
                }

                if (error.response.status === 403) {
                    console.log('ERREUR 403')
                    toast.showToast('error', 'Code 403 : Vous n\'êtes pas autorisé à voir ces informations', 2000)
                }

                if (error.response && error.response.status === 498) {
                    const currentPage = window.location.pathname;
                    if (currentPage != '/login') // Evite de remplacer la currentPage par login en cas d'appels multiples à l'API
                    {
                        window.stop()
                        toast.showToast('error', 'Session expirée, reconnectez-vous', 2000)
                        await authAPI.logout()
                        userManager.goToLoginPage();
                    }
                }

                return error
            }
        });
}
